import { Fragment, ReactNode } from 'react'

import DonationNavbar from '~/donation/components/DonationNavbar'
import { Breakpoint, useCheckBreakpoint } from '~/utils'
import useBackground from '~/donation/hooks/useBackground'
import MenuBar from '~/donation/components/MenuBar'
import DropdownMenu from '~/donation/components/DropdownMenu/DropdownMenu'
import MenuAltIcon from '~/components/Icons/svgs/MenuAltIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import { Footer } from '~/components/Footer'

function DonationPageWrapper({ children }: { children: ReactNode }): React.ReactElement {
  const isSmallScreen = useCheckBreakpoint({ lt: Breakpoint.MD })
  const background = useBackground()
  const style = {
    backgroundImage: `url(${background})`,
  }

  return (
    <Fragment>
      <div className="box-content min-h-screen">
        <DonationNavbar />
        <div className="flex flex-col w-full min-h-screen-off-16 p-5 md:py-7 md:px-20">
          <div
            className="w-full min-h-screen-off-32 text-center rounded bg-blue-strong-2 bg-no-repeat bg-center md:bg-90 xl:bg-auto"
            style={style}
          >
            <div className="relative py-3.5 md:pt-9 md:pb-4">
              <MenuBar />
              {isSmallScreen && (
                <DropdownMenu>
                  <SVGIcon icon={MenuAltIcon} pathClassName="text-white" />
                </DropdownMenu>
              )}
            </div>
            {children}
          </div>
        </div>
      </div>
      <Footer />
    </Fragment>
  )
}

export default function DonationLayout(page: React.ReactElement): React.ReactElement {
  return <DonationPageWrapper>{page}</DonationPageWrapper>
}
